
export enum LancamentoCaixaEnum {
    Recebimento = 0,
    Pagamento = 1,
}